import { MouseEventHandler, CSSProperties } from "react";
import { CancelBlackIcon } from "../../asset/image";
import { useSelectTheme } from "../../store";
import { darken } from "../../lib";

export interface ButtonCancelProps {
  onClick: MouseEventHandler;
  bgColor?: string;
  ariaLabel?: string;
  size?: "small" | "medium" | "large";
  type?: "button" | "submit" | "reset";
}

export const ButtonCancel = (props: ButtonCancelProps) => {
  const { color } = useSelectTheme();
  const { onClick, bgColor, size, ariaLabel, ...rest } = props;

  return (
    <button
      onClick={onClick}
      {...rest}
      aria-label={ariaLabel}
      css={{
        width: size === "small" ? "20px" : "24px",
        minWidth: size === "small" ? "20px" : "24px",
        height: size === "small" ? "20px" : "24px",
        minHeight: size === "small" ? "20px" : "24px",
        backgroundImage: `url(${CancelBlackIcon})`,
        backgroundPosition: "center",
        backgroundSize: "20px 20px",
        backgroundRepeat: "no-repeat",
        backgroundColor: bgColor ?? "white",
        cursor: "pointer",
        border: "none",
        borderRadius: "5px",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ":focus-visible": {
          outline: `2px solid ${color.primary}`,
          outlineOffset: "2px",
        },
        ":hover": {
          backgroundColor: bgColor ? darken(bgColor, 10) : color.hover,
        },
      }}
    >
      {/* <img width='12' src={CancelBlackIcon}/> */}
    </button>
  );
};
